import { useAuth0 } from '@auth0/auth0-react'
import { useMemo } from 'react'
import { useQueryWithStore } from 'react-admin'
import { AppState, User_fields } from 'src/types/globalTypes'

const initialValues: User_fields = {
  id: '',
  name: '',
  auth0_id: '',
  isSuperuser: false,
  disable_user: false,
  permission_group_ids: [],
}

export default function useUser() {
  const { user } = useAuth0()

  const { data, total, loading, loaded, error } = useQueryWithStore<AppState>({
    type: 'getList',
    resource: 'user',
    payload: {
      filter: { auth0_id: user?.sub || '' },
      sort: { field: 'name', order: 'ASC' },
      limit: 1,
    },
  })

  const userData = useMemo(() => {
    if (loaded && total === 1 && data?.[0]) {
      return data[0] as User_fields
    }
    return initialValues
  }, [loaded, total, data])

  return {
    data: userData,
    isSuperuser: userData.isSuperuser,
    total: total || 0,
    isDisable: userData.disable_user,
    loading,
    loaded,
    error,
  }
}
